import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'fury-assign-claim-question',
  templateUrl: './assign-claim-question.component.html',
  styleUrls: ['./assign-claim-question.component.scss']
})
export class AssignClaimQuestionComponent implements OnInit {
  step !: number;
  panelOpenState = false;
  claimQuestions: any[];
  coveredItemQuestions: any [];
  selectedItems: any[] = [];
  constructor(
    public dialogRef: MatDialogRef<AssignClaimQuestionComponent>,
    private apiService: ApiService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
      this.getAllQlaimQuestion();
     }

  ngOnInit(): void {
  }

  cancel(): void {
    this.dialogRef.close();
  };
  getAllQlaimQuestion(){
    this.apiService.get('admin/claim/claim-question/get-claim-questions?page=1&size=30').subscribe((res: HttpResponse<any>)=>{
      if(res.body?.claimQuestions){
        this.claimQuestions = res.body?.claimQuestions?.data;
        this.claimQuestinDetais();
      }
    }, (err: HttpErrorResponse)=>{
      this.apiService.alert(err.message, ErrorType.Error);
    })
  };
  claimQuestinDetais(){
    this.apiService.get(`admin/claim/covered-item-claim-question/get-covered-item-claim-questions/${this.data}`).subscribe((res: HttpResponse<any>)=>{
      if(res.body){
        this.coveredItemQuestions = res.body?.coveredItemQuestions;
        this.coveredItemQuestions.forEach(coveredItemQuestion => {
          const matchingQuestion = this.claimQuestions.find(
            question => question.claimQuestionId === coveredItemQuestion.question.claimQuestionId
          );
    
          if (matchingQuestion) {
            coveredItemQuestion.questionAnswers.forEach(coveredAnswer => {
              const matchingAnswer = matchingQuestion.questionAnswers.find(
                answer => answer.claimQuestionAnswerId === coveredAnswer.answer.claimQuestionAnswerId
              );
    
              if (matchingAnswer) {
                matchingQuestion.checked = true; 
                matchingAnswer.checked = true;
                this.addToSelectedItems(matchingQuestion, matchingAnswer);
              }
            });
          }
        });
      }
    })
  }


  toggleChildren(parentItem : any, index: number) {
    parentItem.questionAnswers.forEach(answer => {
      answer.checked = parentItem.checked;
      this.addToSelectedItems(parentItem, answer);
    });
    if(parentItem.checked){
      this.setStep(index);
    } else{
      this.step = null;
    }
  }

  updateParent(parentItem : any, index: number) {
    parentItem.checked = parentItem.questionAnswers.some(answer => answer.checked);
    this.addToSelectedItems(parentItem);
    if(!parentItem.checked){
      this.step = null;
    }
  };

  addToSelectedItems(parentItem, childItem = null) {
    if (parentItem.checked && childItem) {
      this.selectedItems.push({
        claimQuestionId: parentItem.claimQuestionId,
        claimQuestionAnswerId: childItem.claimQuestionAnswerId
      });
    } else if (!parentItem.checked) {
      this.selectedItems = this.selectedItems.filter(item =>
        !(item.claimQuestionId === parentItem.claimQuestionId && (!childItem || item.claimQuestionAnswerId === childItem.claimQuestionAnswerId))
      );
    }
  }

  assign() {
    this.selectedItems = this.claimQuestions
      .filter(item => item.checked)
      .map(item => {
        return {
          claimQuestionId: item.claimQuestionId,
          answerId: item.questionAnswers.filter(answer => answer.checked).map(answer => answer.claimQuestionAnswerId)
        };
      });

    const data = {
      coveredItemId: this.data,
      question: this.selectedItems
    };
    if(this.selectedItems.length){
      this.apiService.post('admin/claim/covered-item-claim-question/save-covered-item-claim-question', data).subscribe((res: HttpResponse<any>)=>{
        if(res){
          this.apiService.alert(res.body?.message, ErrorType.Success);
          this.cancel();
        }
      }, (err: HttpErrorResponse) =>{
        this.apiService.alert(err.message, ErrorType.Error);
      })
    } else {
      this.apiService.alert('Please select claim question', ErrorType.Error);
    }
   
  };
  setStep(index: number) {
    this.step = index;
  };

}
